import humps from 'humps'
import { defineAction } from '_/utils/redux'
import * as budgetServices from '_/services/inspection-budget'

export const GET_INSPECTION_BUDGETS = defineAction('GET_INSPECTION_BUDGETS')
export const GET_AI_INSPECTION_DATA = defineAction('GET_AI_INSPECTION_DATA')

export const CREATE_INSPECTION_BUDGET = defineAction('CREATE_INSPECTION_BUDGET')
export const UPDATE_INSPECTION_BUDGET = defineAction('UPDATE_INSPECTION_BUDGET')
export const GET_INSPECTION_BUDGET_BY_ID = defineAction('GET_INSPECTION_BUDGET_BY_ID')
export const DUPLICATE_INSPECTION_BUDGET = defineAction('DUPLICATE_INSPECTION_BUDGET')

export const GET_INSPECTION_TRADESMEN = defineAction('GET_INSPECTION_TRADESMEN')
export const CREATE_INSPECTION_TRADESMAN = defineAction('CREATE_INSPECTION_TRADESMAN')
export const GET_INSPECTION_TRADESMAN_BY_ID = defineAction('GET_INSPECTION_TRADESMAN_BY_ID')
export const UPDATE_INSPECTION_TRADESMAN = defineAction('UPDATE_INSPECTION_TRADESMAN')

export const GET_COMPARTMENTS = defineAction('GET_COMPARTMENTS')
export const GET_INSPECTION_BUDGET_RESOLUTION_MATERIAL_UNIDS = defineAction(
  'GET_INSPECTION_BUDGET_RESOLUTION_MATERIAL_UNIDS'
)

export const getInspectionBudgets = params => async (dispatch, getState) => {
  const formattedParams = humps.decamelizeKeys(params)
  const data = await budgetServices.getInspectionBudgets(getState().user.authToken)(formattedParams)
  dispatch({
    type: GET_INSPECTION_BUDGETS.ACTION,
    payload: async () => data,
  })
  return data
}

export const getInspectionBudgetById = id => async (dispatch, getState) => {
  const data = await budgetServices.getInspectionBudgetById(getState().user.authToken)(id)
  dispatch({
    type: GET_INSPECTION_BUDGET_BY_ID.ACTION,
    payload: async () => data,
  })
  return data
}

export const getAiInspectionData = payload => async (dispatch, getState) => {
  const data = await budgetServices.getAiInspectionData(getState().user.authToken, payload)
  dispatch({
    type: GET_AI_INSPECTION_DATA.ACTION,
    payload: async () => data,
  })
  return data
}

export const createInspectionBudget = payload => async (dispatch, getState) => {
  const data = await budgetServices.createInspectionBudget(getState().user.authToken, payload)
  dispatch({
    type: CREATE_INSPECTION_BUDGET.ACTION,
    payload: async () => data,
  })
  return data
}

export const updateInspectionBudget = (id, payload) => async (dispatch, getState) => {
  const data = await budgetServices.updateInspectionBudget(getState().user.authToken, id, payload)
  dispatch({
    type: UPDATE_INSPECTION_BUDGET.ACTION,
    payload: async () => data,
  })
  return data
}

export const duplicateInspectionBudget = (id, payload) => async (dispatch, getState) => {
  const data = await budgetServices.duplicateInspectionBudget(
    getState().user.authToken,
    id,
    payload
  )
  dispatch({
    type: DUPLICATE_INSPECTION_BUDGET.ACTION,
    payload: async () => data,
  })
  return data
}

export const getInspectionTradesmen = params => async (dispatch, getState) => {
  const formattedParams = humps.decamelizeKeys(params)
  const response = await budgetServices.getInspectionTradesmen(getState().user.authToken)(
    formattedParams
  )
  const data = Array.isArray(response)
    ? {
        count: response.length,
        results: response,
      }
    : response
  dispatch({
    type: GET_INSPECTION_TRADESMEN.ACTION,
    payload: async () => data,
  })
  return data
}

export const createInspectionTradesman = payload => async (dispatch, getState) => {
  const data = await budgetServices.createInspectionTradesman(getState().user.authToken, payload)
  dispatch({
    type: CREATE_INSPECTION_TRADESMAN.ACTION,
    payload: async () => data,
  })
  return data
}

export const getInspectionTradesmanById = id => async (dispatch, getState) => {
  const data = await budgetServices.getInspectionTradesmanById(getState().user.authToken, id)
  dispatch({
    type: GET_INSPECTION_TRADESMAN_BY_ID.ACTION,
    payload: async () => data,
  })
  return data
}

export const updateInspectionTradesman = (id, payload) => async (dispatch, getState) => {
  const data = await budgetServices.updateInspectionTradesman(
    getState().user.authToken,
    id,
    payload
  )
  dispatch({
    type: UPDATE_INSPECTION_TRADESMAN.ACTION,
    payload: async () => data,
  })
  return data
}

export const downloadInspectionBudgetPdf = (id, options) => async (dispatch, getState) => {
  const data = await budgetServices.downloadInspectionBudgetPdf(
    getState().user.authToken,
    id,
    options
  )
  return data
}

export const getInspectionBudgetResolutionMaterialUnids = params => async (dispatch, getState) => {
  const formattedParams = humps.decamelizeKeys(params ?? {})
  const data = await budgetServices.getInspectionBudgetResolutionMaterialUnids(
    getState().user.authToken
  )(formattedParams)
  dispatch({
    type: GET_INSPECTION_BUDGET_RESOLUTION_MATERIAL_UNIDS.ACTION,
    payload: async () => data,
  })
  return data
}
